import { isRejected, Middleware } from "@reduxjs/toolkit";
import { State } from "../store/state/state";
import { storeAPIError } from "../store/actions";

/**
 * Turns every rejected thunk into the global error toast.
 *
 * A thunk whose argument carries `silent: true` opts out: some failures are an
 * expected answer rather than a fault — asking for a bid on a day that has
 * never been calculated answers 404, and that belongs in the page as a hint,
 * not in a red toast.
 */
const APIErrors: Middleware<{}, State> = ({ dispatch }) => {
  return (next) => async (action) => {
    if (isRejected(action)) {
      if (action.error.message?.toLowerCase() === "rejected") return;

      const arg = (action as { meta?: { arg?: { silent?: boolean } } }).meta?.arg;

      if (arg?.silent) return next(action);

      dispatch(storeAPIError(action?.error?.message!));
    }

    return next(action);
  };
};

export default APIErrors;
